<template>
  <embedded
    :iframeSrc="iframeSrc"
    :iframeStyle="iframeStyle"
  />
</template>

<script>
import Embedded from './custom-components/Embedded.vue'

export default {
  components: {
    Embedded
  },
  data() {
    return {
      iframeSrc: 'https://portal-v4.robo-hi.com/',
      iframeStyle: {
        position: 'relative',
        border: '1px solid #a1a5ac',
        width: '100%',
        height: 'calc(100vh - 150px)',
        marginTop: '16px'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RoboHI.vue